import React, { useState } from 'react'
import Swal from 'sweetalert2';
import ReCAPTCHA from 'react-google-recaptcha';
import CountryData from './CountryData.json'
import { createAtelierRegistration } from '../../API/atelierRegistrationAPI';

const FormSection = () => {

        const [error, setError] = useState("");
        const [recaptchaValue, setRecaptchaValue] = useState(null);
        const [countris, setCountries] = useState(CountryData)
        
        const handleRecaptchaChange = (value) => {
            setRecaptchaValue(value);
        };
    
        const validateEmail = (email) => {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return emailRegex.test(email);
        };
        
        const handleChange = (e) => {
            const { name, value } = e.target;
        
            setFormData({ ...formData, [name]: value });
        
            if (name === "email") {
            if (validateEmail(value)) {
                setError(""); 
            } else {
                setError("Please enter a valid email address.");
            }
            }
        };

        const [formData, setFormData] = useState({
            firstName: "",
            lastName: "",
            email: "",
            countryCode: "", 
            mobile: "",
            participants: "",
            date: "",
            time: "",
          });


    const handleSubmit = async (e) => {
                e.preventDefault();
            
                if (!validateEmail(formData.email)) {
                    setError("Please enter a valid email address.");
                    Swal.fire({
                        icon: 'error',
                        title: 'Invalid Email',
                        text: 'Please enter a valid email address.',
                    });
                    return;
                }
        
                const formatTime = (time) => {
                    return `${time}:00`; 
                };
            
                const registrationData = {
                    name: `${formData.firstName} ${formData.lastName}`,
                    email: formData.email,
                    mobileNo: `${formData.countryCode}${formData.mobile}`,
                    NoOfParticipants: parseInt(formData.participants),
                    date: formData.date,
                    time: formatTime(formData.time),
                };
            
                try {
                    const response = await createAtelierRegistration(registrationData);
                    console.log("response:", response)
                    if (response.success) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Registration Successful',
                            text: 'Your inquiry has been submitted successfully!',
                        });
        
                        setFormData({
                            firstName: '',
                            lastName: '',
                            email: '',
                            countryCode: '', 
                            mobile: '',
                            participants: '',
                            date: '',
                            time: ''
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Registration Failed',
                            text: 'Failed submission. Please try again.',
                        });
                    }
                } catch (error) {
                    console.error('API Error:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'An error occurred. Please try again.',
                    });
                }
            };

  return (
    <section>
        <div id="signup-form" className="w-full">
                    <div className="w-full bg-[#F5E9D7] flex items-center justify-center py-5">
                        <div className='w-[80%] 2xl:w-[70%] mt-5 md:mb-10'>
                            <div className='w-full mt-10 lg:mt-0'>
                                <form onSubmit={handleSubmit}>
                                    <div className="grid grid-cols-1 gap-4 mt-4 lg:grid-cols-2 lg:mt-9">
                                        <div>
                                            <input
                                                type="text"
                                                id="firstName"
                                                name="firstName"
                                                className="w-full px-4 py-4 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4A373] border-solid border-2 border-[#41220E] bg-[#F5E9D7] bg-opacity-60 placeholder-[#41220E] placeholder-opacity-50 placeholder:font-bold placeholder:text-[18px]"
                                                placeholder="First Name"
                                                value={formData.firstName}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div>
                                            <input
                                                type="text"
                                                id="lastName"
                                                name="lastName"
                                                className="w-full px-4 py-4 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4A373] border-solid border-2 border-[#41220E] bg-[#F5E9D7] bg-opacity-60 placeholder-[#41220E] placeholder-opacity-50 placeholder:font-bold placeholder:text-[18px]"
                                                placeholder="Last Name"
                                                value={formData.lastName}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-1 gap-4 mt-4 lg:grid-cols-2 lg:mt-9">
                                        <div className="mt-4 lg:mt-8">
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                className="w-full px-4 py-4 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4A373] border-solid border-2 border-[#41220E] bg-[#F5E9D7] bg-opacity-60 placeholder-[#41220E] placeholder-opacity-50 placeholder:font-bold placeholder:text-[18px]"
                                                placeholder="Email"
                                                value={formData.email}
                                                onChange={handleChange}
                                            />
                                            {error && <p style={{ color: "red" }}>{error}</p>}
                                        </div>
                                        <div className="mt-4 lg:mt-8">
                                            <div className="flex items-center">
                                                <select
                                                    type="text"
                                                    id="countryCode"
                                                    name="countryCode"
                                                    className="w-[30%] px-2 py-4 mr-5 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4A373] border-solid border-2 border-[#41220E] bg-[#F5E9D7] bg-opacity-60 placeholder-[#41220E] placeholder-opacity-50 placeholder:font-bold placeholder:text-[18px]"
                                                    value={formData.countryCode}
                                                    onChange={handleChange}
                                                >
                                                    <option value='' hidden>
                                                        -- Select --
                                                    </option>
                                                    {countris.map((item) => (
                                                        <option key={item.code} value={item.dial_code}>
                                                            {item.name} ({item.dial_code})
                                                        </option>
                                                    ))}
                                                </select>

                                                <input
                                                    type="tel"
                                                    id="mobile"
                                                    name="mobile"
                                                    className="w-[70%] px-4 py-4 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4A373] border-solid border-2 border-[#41220E] bg-[#F5E9D7] bg-opacity-60 placeholder-[#41220E] placeholder-opacity-50 placeholder:font-bold placeholder:text-[18px]"
                                                    value={formData.mobile}
                                                    onChange={handleChange}
                                                    placeholder="Mobile number"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-1 gap-4 mt-4 lg:grid-cols-3 lg:mt-9">
                                        <div className="mt-4 lg:mt-8">
                                            <input
                                                type="number"
                                                id="participants"
                                                name="participants"
                                                className="w-full px-4 py-4 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4A373] border-solid border-2 border-[#41220E] bg-[#F5E9D7] bg-opacity-60 placeholder-[#41220E] placeholder-opacity-50 placeholder:font-bold placeholder:text-[18px]"
                                                placeholder="No of Participants"
                                                value={formData.participants}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="mt-4 lg:mt-8">
                                            <input
                                                type="date"
                                                id="date"
                                                name="date"
                                                className="w-full px-4 py-4 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4A373] border-solid border-2 border-[#41220E] bg-[#F5E9D7] bg-opacity-60 placeholder-[#41220E] placeholder-opacity-50 placeholder:font-bold placeholder:text-[18px]"
                                                placeholder="Date"
                                                value={formData.date}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="mt-4 lg:mt-8">
                                            <input
                                                type="time"
                                                id="time"
                                                name="time"
                                                className="w-full px-4 py-4 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4A373] border-solid border-2 border-[#41220E] bg-[#F5E9D7] bg-opacity-60 placeholder-[#41220E] placeholder-opacity-50 placeholder:font-bold placeholder:text-[18px]"
                                                placeholder="Time"
                                                value={formData.time}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className='py-5'>
                                        <ReCAPTCHA
                                        sitekey="6Lc0_J0qAAAAALj8EKQKFG1Uj2sDGkSyvvS47g4P"
                                        onChange={handleRecaptchaChange}
                                        />
                                    </div>
                                    <div className="mt-8 md:mt-9 flex items-center justify-center">
                                        <button
                                            type="submit"
                                            className={`bg-[#41220E] text-white font-bold text-[20px] py-2 lg:py-4 px-10 rounded-lg hover:bg-[#61381c] focus:outline-none focus:ring-2 focus:ring-[#492a15] ${
                                            recaptchaValue
                                                ? "hover:bg-[#41220E] disabled:cursor-pointer"
                                                : "bg-[#4b392d] cursor-not-allowed"
                                            }`}
                                            disabled={!recaptchaValue}>
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
    </section>
  )
}

export default FormSection
